import React, { Fragment } from "react";

import { useMediaQuery } from "react-responsive";

import banner1 from "../../assets/images/banner1.jpg";
import banner2 from "../../assets/images/banner2.jpg";
import company_photo1 from "../../assets/images/company_photo1.jpg";
import company_photo1_mobile from "../../assets/images/company_photo1_mobile.jpg";
import company_photo2 from "../../assets/images/company_photo2.jpg";
import { Section as BannerSection } from "../../components/BannerSection/styles"
import { ButtonLink } from "../../components/ButtonLink/ButtonLink";
import { ResultSection } from "../../components/ResultSection/ResultSection";
import { resultData } from "../../config/resultData";
import { Section, TitleH2 } from "../../styles/sharedStyles";

import {
  BannerText,
  BannerText2,
  BannerTitleH1,
  BannerTitleH2,
  BottomBanner,
  Container,
  Icon,
  Img,
  Img2,
  InfoBlock,
  LinkWrapper,
  Paragraph,
  PhotoBlock,
  ResultTitle,
  StyledH2,
  StyledP,
  SubParagraph,
  Text,
  Text2,
  TextList,
} from "./styles";

const result = resultData.about_company_page

export const AboutCompany = () => {
  const isMobile = useMediaQuery({ maxWidth: 1023 });

  return (
    <Fragment>
      <BannerSection bgImage={banner1}>
        <BannerTitleH1>Прохорова Консалт – это больше, чем агентство</BannerTitleH1>
        <BannerText>Наша история началась 2021 году. За это время мы помогли решить больше 1000 карьерных задач,
              найти более 100 ИТ талантов и подарить профессию ИТ рекрутера 60 выпускникам.
        </BannerText>
      </BannerSection>
      <Section>
        <Container>
          <TitleH2>Наша миссия</TitleH2>
        </Container>
        <Paragraph>
            Мы уверены в том, что для каждой победы нужна поддержка. Наша команда предоставляет
            бутиковый сервис, который всегда сопровожден личным подходом к каждому клиенту.
        </Paragraph>
        {isMobile
          ? <Img src={company_photo1_mobile} alt="company photo" />
          : <Img src={company_photo1} alt="company photo" />
        }
      </Section>
      <Section>
        <Container>
          <TitleH2>Мотивируем <span>на результат</span></TitleH2>
        </Container>
        <SubParagraph>
            Мы построили экосистему, которая помогает решить боли карьеры и трудоустройства. Наши клиенты всегда
            могут рассчитывать на нас и с уверенностью смотрят в будущее.
        </SubParagraph>
        <Paragraph>
            Мы специализируемся только на том, в чем обладаем глубокими знаниями и опытом. Наша репутация в
            отрасли — результат многолетней работы и успешных проектов.
        </Paragraph>
      </Section>
      <Section>
        <PhotoBlock>
          <Img2 src={company_photo2} alt="Любовь Прохорова"/>
          <InfoBlock>
            <StyledH2>Любовь <span>Прохорова</span></StyledH2>
            <StyledP>Основательница Прохорова Консалт</StyledP>
            <TextList>
              <Text>Написала диссертацию по эмоциональному выгоранию в IT</Text>
              <Text>Магистр практической психологии и коучинга</Text>
              <Text>Высшее образование в HR-менеджменте и PR</Text>
            </TextList>
            <LinkWrapper
              href="https://www.linkedin.com/in/%D0%BB%D1%8E%D0%B1%D0%BE%D0%B2%D1%8C-%D0%BF%D1%80%D0%BE%D1%85%D0%BE%D1%80%D0%BE%D0%B2%D0%B0-755167185/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Профиль LinkedIn</span>
              <Icon />
            </LinkWrapper>
            <Text2>Привет! Меня зовут Любовь Прохорова, и я рада, что ты заглянул на сайт Прохорова Консалт.
                Давай на "ты"? Мне кажется, так будет проще и приятнее общаться.</Text2>
            <Text2>Я еще ни разу не пожалела, что ушла из найма и стала помогать другим в их развитии.
                Сложно объяснить, но когда у нас получается решить еще один сложный кейс, то я ощущаю мурашки в
                животе и сильную пульсацию в груди – одним словом счастье. </Text2>
            <Text2>Убеждена, что именно искренние человеческие отношения лежат в
                основе любого успешного сотрудничества.</Text2>
            <Text2>Добро пожаловать!</Text2>
          </InfoBlock>

        </PhotoBlock>
      </Section>
      <Section>
        <ResultTitle>Наши результаты <span>говорят сами за себя</span></ResultTitle>
        <ResultSection data={result}/>
      </Section>
      <BottomBanner bgImage={banner2}>
        <BannerTitleH2>Развитие карьеры, рост команды и смена профессии начинается здесь</BannerTitleH2>
        <BannerText2>Мы помогаем открыть свой потенциал и получить работу мечты.</BannerText2>
        <ButtonLink
          hasBorder={false}
          toPage="/services"
          title="Все услуги"
        />
      </BottomBanner>
    </Fragment>
  );
};

